import { callFunction } from "../cao";

export const setErc721BlankMint = async (proxyAddr, amount, price) => {
    // console.log("setErc721BlankMint", proxyAddr, amount, price);
    return await callFunction(proxyAddr, "mint", [amount], price, true);
};